import store from "@src/reducers/store";
import { TransportConfigurationToClientPayloadBuilder } from "./transfer-configuration-to-client-payload-builder";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import apiUseCases from "@src/cloud-connect/api";

export const buildPayloadAndTransferConfigurationUseCase = async () => {
  // collect data
  const transferData = store.getState().yourSlice.editStructurePageTransferData;
  const { connected_via_client } =
    store.getState().yourSlice.connectionView.source;
  const rootNode = getMachineStructureNodeset().getRootNode();

  // build payload
  const payload = new TransportConfigurationToClientPayloadBuilder(
    connected_via_client,
    transferData.nodeset.name,
    rootNode,
  ).build();

  // call the api
  const data = await apiUseCases.saveStructureFunction(payload);
  return data;
};
